import { notification } from "antd"; // For displaying notification
import "antd/dist/antd.css"; // css for antd
import mixpanel from "mixpanel-browser"; // This is for logging user events on mixpanel
import Pusher from "pusher-js"; // This package is for realtime notification
import React from "react";
import ReactDOM from "react-dom";
import { MixpanelProvider } from "react-mixpanel";
import { setPusherClient } from "react-pusher";
import { Detector } from "react-detect-offline"; // Components that track offline and online state. Render certain content only when online (or only when offline).
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import ReactPixel from "react-facebook-pixel"; // Used for tracking facebook pixel
import App from "./App"; // MAIN APP
import ScrollToTop from "./components/app/ScrollToTop"; // Scroll to top component
// IMPORT ALL CUSTOM CSS
import "./css/animate.css";
import "./css/authForm.css";
import "./css/theme/index.css";
import "./css/custom.css";
import "./css/page-loader.css";
import "./css/user_prompt.css";
import "./css/signup.css";
import "./css/responsive.css";
import { history, store } from "./helpers"; // HISTORY AND REDUX
import { InterceptorService } from "./services/interceptor"; // The request interceptor blocks invalid outgoing requests to avoid 403 or 401 errors
import * as Sentry from "@sentry/react"; // Sentry's React SDK enables automatic reporting of errors and exceptions.
import { Integrations } from "@sentry/tracing";

// INITIALIZE MIXPANEL
mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);

window.store = store;

InterceptorService(store);
// initialize google analytics

// set notification placement globally
notification.config({
  placement: "topLeft"
});

if (process.env.REACT_APP_ENVIRONMENT === "production") {
  // To use Sentry SDK, call Sentry.init(options) before you mount your React component.
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN_URL,
    release: process.env.REACT_APP_LATEST_RELEASE,
    /* You can use the ignoreErrors option to filter out errors that match a certain pattern. 
    This option receives a list of strings and regular expressions to match against the error message. */
    ignoreErrors: [
      "Cannot read property 'audioPlayer' of null",
      "Network Error",
      "Unable to find node on an unmounted component.",
      "Error: Unable to find node on an unmounted component.",
      "Request failed with status code 401",
      "Request failed with status code 404",
      "Request failed with status code 500"
    ],
    /* The beforeSend callback is passed both the event and a second argument, 
    hint, that holds one or more hints. */
    beforeSend(event, _hint) {
      if (!event.message && !event.exception) {
        return null;
      }
      if (event.exception) {
        const exceptionValue = event.exception.values[0].value;
        // ignore error
        if (exceptionValue) {
          if (
            exceptionValue.match(/audioPlayer/i) ||
            exceptionValue.match(/Network Error/i) ||
            exceptionValue.match(/unmounted component/i) ||
            exceptionValue.match(/getReadModeRender/i) ||
            exceptionValue.match(/getReadModeConfig/i) ||
            exceptionValue.match(/getReadModeExtract/i) ||
            exceptionValue.match(/188/i) ||
            exceptionValue.match(/#188/i) ||
            exceptionValue.match(/querySelector/i) ||
            exceptionValue.match(/getInstance/i) ||
            exceptionValue.match(/null is not an object/i) ||
            exceptionValue.match(/focus/i) ||
            exceptionValue.match(/tgetT/i)
          ) {
            return null;
          }
        }
      }
      return event;
    },
    tracesSampleRate: 1.0,
    environment: process.env.REACT_APP_ENVIRONMENT,
    integrations: [new Integrations.BrowserTracing()]
  });
}

// facebook pixel
const options = {
  autoConfig: true, // set pixel's autoConfig
  debug: false // enable logs
};
ReactPixel.init(process.env.REACT_APP_FACEBOOK_PIXEL_ID, null, options);
ReactPixel.pageView(); // For tracking page view

// PUSHER SETUP
// To use react-pusher, you need to hand over your instance of the pusher service first.
// Otherwise the Pusher React component can't receive messages:
const pusherClient = new Pusher(process.env.REACT_APP_PUSHER_KEY);
setPusherClient(pusherClient);

ReactDOM.render(
  <MixpanelProvider mixpanel={mixpanel}>
    <Provider store={store}>
      <Router history={history}>
        <ScrollToTop>
          {/* DETECTOR COMPONENT: Component that calls its render prop every time the connection state changes. 
          It's used to track offline and online state. 
          The render prop is supplied with an object with an online boolean value. */}
          <Detector
            render={({ online }) => {
              return <App online={online} />;
            }}
          />
        </ScrollToTop>
      </Router>
    </Provider>
  </MixpanelProvider>,
  document.getElementById("root")
);
